import { IconButton } from "@chakra-ui/react";
import { useEffect, useMemo, useState } from "react";
import { BsFillPauseFill, BsFillPlayFill } from "react-icons/bs";

function decodeAudio(encodedAudioData: string): string {
  // Decode the base64-encoded string into binary data
  const decodedAudioData = atob(encodedAudioData);

  // Convert the binary data to an array buffer
  const arrayBuffer = new ArrayBuffer(decodedAudioData.length);
  const view = new Uint8Array(arrayBuffer);
  for (let i = 0; i < decodedAudioData.length; ++i) {
    view[i] = decodedAudioData.charCodeAt(i);
  }

  // Create a blob object from the array buffer
  const audioBlob = new Blob([arrayBuffer], { type: "audio/mp3" });

  // Create a URL for the audio blob
  const url = URL.createObjectURL(audioBlob);

  // Set the audio URL in state
  //setAudioUrl(url);
  return url;
}

export function AudioPlayer({
  encodedAudioData,
  activated,
}: {
  encodedAudioData: string;
  activated: boolean;
}) {
  const [audioUrl, setAudioUrl] = useState<string | undefined>(undefined);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const player: HTMLAudioElement | undefined = useMemo(() => {
    if (!audioUrl) return undefined;
    const audioElem = new Audio(audioUrl);
    audioElem.addEventListener("playing", (event) => {
      setIsPlaying(true);
    });
    audioElem.addEventListener("pause", (event) => {
      setIsPlaying(false);
    });
    return audioElem;
  }, [audioUrl]);

  useEffect(() => {
    if (
      encodedAudioData == "" &&
      encodedAudioData == undefined &&
      encodedAudioData == null
    )
      return;
    const decodedAudioUrl = decodeAudio(encodedAudioData);
    setAudioUrl(decodedAudioUrl);
  }, [encodedAudioData]);

  useEffect(() => {
    setIsPlaying(false);
    player?.pause();
  }, [activated]);
  return (
    <>
      {activated ? (
        <>
          {isPlaying && player && (
            <IconButton
              icon={<BsFillPauseFill />}
              aria-label="pause"
              variant="outline"
              verticalAlign="middle"
              textColor={"white"}
              size="sm"
              onClick={() => player.pause()}
            />
          )}
          {!isPlaying && player && (
            <IconButton
              icon={<BsFillPlayFill />}
              aria-label="play"
              variant="outline"
              verticalAlign="middle"
              textColor={"white"}
              size="sm"
              onClick={() => player.play()}
            />
          )}
        </>
      ) : null}
    </>
  );
}
